// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YGWEL","b":"styles_b__JRXXQ"};